module.exports = __webpack_public_path__ + "img/smart-house.5f8ede50.png";